import { render, staticRenderFns } from "./Attractors.vue?vue&type=template&id=2ffd74c3&scoped=true&"
import script from "./Attractors.vue?vue&type=script&lang=ts&"
export * from "./Attractors.vue?vue&type=script&lang=ts&"
import style0 from "./Attractors.vue?vue&type=style&index=0&id=2ffd74c3&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffd74c3",
  null
  
)

export default component.exports